import { TRM_STATUSES } from '@views/GomsOrderDashboard/constant';

// TRM statuses that require manual review action
export const REVIEWABLE_TRM_STATUSES = [TRM_STATUSES.ON_HOLD, TRM_STATUSES.CHECK_FAILED];
